export interface ReturnCarrierPickerGroup {
  label: string;
  /** rate.carrier values this checkbox controls; the first is canonical. */
  carriers: readonly [string, ...string[]];
}

/** Merchant-facing picker groups, same vocabulary as DEFAULT_CARRIER_ALLOWLIST so a carrier is governable per location exactly when the admin cap can govern it. A brand checkbox owns every rate.carrier string that means that brand (FedExDefault, USPSReturns). */
export const returnSelectableCarrierGroups: readonly ReturnCarrierPickerGroup[] =
  [
    { label: "UPS", carriers: ["UPS"] },
    { label: "UPS SurePost", carriers: ["UPSSurePost"] },
    { label: "FedEx", carriers: ["FedEx", "FedExDefault"] },
    { label: "FedEx SmartPost", carriers: ["FedExSmartPost"] },
    { label: "USPS", carriers: ["USPS", "USPSReturns"] },
    { label: "Canada Post", carriers: ["CanadaPost"] },
    { label: "Australia Post", carriers: ["AustraliaPost"] },
    { label: "DHL eCommerce", carriers: ["DhlEcs"] },
    { label: "DHL Express", carriers: ["DHLExpress"] },
    { label: "Royal Mail", carriers: ["RoyalMailV3"] },
  ];

const returnSelectableCarrierValues = new Set<string>(
  returnSelectableCarrierGroups.flatMap((group) => [...group.carriers]),
);

/** WeGrow/NZ Post/Seko and platform-Sendcloud rates are Redo-provided but outside the picker vocabulary, so a selection must leave them alone. */
export function isReturnSelectableCarrier(carrier: string): boolean {
  return returnSelectableCarrierValues.has(carrier);
}

/** Brand label for a picker carrier; falls back to the raw rate.carrier string. */
export function getReturnSelectableCarrierLabel(carrier: string): string {
  return (
    returnSelectableCarrierGroups.find((group) =>
      group.carriers.includes(carrier),
    )?.label ?? carrier
  );
}

/** Every rate.carrier string a stored picker carrier governs; unknown carriers govern only themselves. */
export function getReturnSelectableCarrierGroupMembers(
  carrier: string,
): readonly string[] {
  return (
    returnSelectableCarrierGroups.find((group) =>
      group.carriers.includes(carrier),
    )?.carriers ?? [carrier]
  );
}
